import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    Input,
    Inject,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { DialogData } from 'app/modules/factura/lista-facturas/lista-facturas.component';
import { CoalService } from 'app/services/coal.service';
import {
    MostrarExcepcion,
    MostrarSpinner,
    OcultarSpinner,
} from 'app/store/actions/utils.action';
import { AppState, selectOperacionState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import { DialogNuevoClienteService } from './dialog-nuevo-cliente.service';
import { FacturaService } from 'app/modules/factura/lista-facturas/factura.service';

@Component({
    selector: 'dialog-nuevo-cliente',
    templateUrl: './dialog-nuevo-cliente.component.html',
    styleUrls: ['./dialog-nuevo-cliente.component.scss'],
})
export class DialogNuevoClienteComponent implements OnInit {
    edicionDatosCliente: any;
    regimenFiscal: any;
    usoFactura: any;
    regFiscal: any;
    estado: any;
    pais: any;
    bloquearPaEsMun: boolean = false;
    datosAdicionales: boolean = false;
    contadorMostrarDatos: number;
    formDatosCliente: any;
    formDatosClienteAdicionales: any;
    lstPais: any;
    lstEstado: any;
    lstMunicipio: any;
    lstAsentamiento: any;
    codigoPostal: any;
    actualizar: any;
    datoseventCliente: any;
    modificarDatos: boolean = false;
    spinner: boolean = false;
    getStateOperacion: any;
    subscribeOperacion: any;
    idOperacion: any;
    counterKeyPressCP = 0;
    verManualmente: boolean = false;
    formularioCompleto: boolean = false;
    nuevoCliente: any;

    rfcReadOnly: boolean = false;
    rfcPaisOnly: boolean = true;
    rfcEstadoOnly: boolean = true;
    rfcMunicipioOnly: boolean = true;
    csfCargado: boolean = false;

    get isRfcReadOnly(): boolean { return this.rfcReadOnly; }
    get isPaisReadOnly(): boolean { return this.rfcPaisOnly; }
    get isEstadoReadOnly(): boolean { return this.rfcEstadoOnly; }
    get isMunicipioReadOnly(): boolean { return this.rfcMunicipioOnly; }
    get isFormularioCompleto(): boolean { return this.formularioCompleto; }

    constructor(
        public dialog: MatDialog,
        private fb: FormBuilder,
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        public dialogRef: MatDialogRef<DialogNuevoClienteComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private _clientService: DialogNuevoClienteService,
        private _facturaService: FacturaService
    ) { }

    ngOnInit() {
        // this.getStateOperacion = this.store.select(selectOperacionState);
        // this.subscribeOperacion = this.getStateOperacion.subscribe(
        //     (operacion) => {
        //         this.idOperacion = operacion.idOperacion;
        //     }
        // );
        this.contadorMostrarDatos = 0;

        this.formularioCliente();
        this.formularioClienteDatoAdicional();
        this.getPais();
        this.CFDI();
        this.edicionDatosCliente = this.data;

        if (this.data.mode === 1) {
            this.datosAdicionales = false;
            this.modificarDatos = false;
        }
        else if (this.data.mode === 2) {
            //console.log(this.edicionDatosCliente.attributes.idPais)
            setTimeout(() => this.ACTCliente(), 1000);
            //console.log(this.edicionDatosCliente.attributes.CP, "codigo postal");
            this.modificarDatos = true;
        }
        else if (this.data.mode === 3) {
            this.datosAdicionales = true;
            this.modificarDatos = false;
        }

        //console.log('DialogNuevoClienteComponent', this.data);
    }
    async onFileSelected() {
        const inputNode: any = document.querySelector('#file');
        const file: File = inputNode.files[0];

        if (file) {
            try {
                this.store.dispatch(MostrarSpinner());
                const fileName = file.name;
                const formData = new FormData();
                formData.append("files", file);
                const res = await this._clientService.postService(formData);
                if (res.status) {
                    let cif = res.cif;
                    //console.log(cif);

                    var usoDeLaFactura = null;
                    var regimenFiscal = null;
                    var eMail = null;
                    var eMailOpcionalNo1 = null;
                    var eMailOpcionalNo2 = null;
                    var data: any[] = null;
                    try {
                        data = await this._clientService.getClienteByRfc(this.data.idEmpresa, cif.Contribuyente.RFC)
                        if (data.length > 0) {
                            console.log("Se encontro cliente:", data);
                            //this.formDatosCliente.controls.rFC.disable({onlySelf: true});
                            this.rfcReadOnly = true;
                            this.edicionDatosCliente = data[0];
                            usoDeLaFactura = this.edicionDatosCliente.attributes.cat_uso_factura.data.id;
                            regimenFiscal = this.edicionDatosCliente.attributes.cat_regimen_fiscal.data.id;
                            eMail = this.edicionDatosCliente.attributes.email;
                            eMailOpcionalNo1 = this.edicionDatosCliente.attributes.emailOpcional1;
                            eMailOpcionalNo2 = this.edicionDatosCliente.attributes.emailOpcional2;
                            //setTimeout(() => this.ACTCliente(), 1000);
                            this.ACTCliente()
                            //console.log(this.edicionDatosCliente.attributes.CP, "codigo postal");
                            this.modificarDatos = true;
                            this.store.dispatch(OcultarSpinner());
                        } else {
                            //this.formDatosCliente.controls.rFC.enable();
                            this.rfcReadOnly = false;
                            this.edicionDatosCliente = null;
                            this.modificarDatos = false;
                            eMail = cif.Ubicacion.CorreoElectronico;
                            this.consultarCP(cif.Ubicacion.CodigoPostal);
                            this.store.dispatch(OcultarSpinner());
                        }
                    }
                    catch (error) {
                        console.log(error);
                        this.store.dispatch(MostrarExcepcion(error));
                        this.store.dispatch(OcultarSpinner());
                    }

                    // Fallback: ID por tipo de RFC (persona física=13, moral=4)
                    const personaFallback = this.detectaTipoRFC(cif.Contribuyente.RFC) == 1 ? 13 : 4;

                    this.formDatosCliente.setValue({
                        nombreRazonSocial: cif.Contribuyente.NombreRazonSocial ?? "",
                        rFC: cif.Contribuyente.RFC ?? "",
                        // usoDeLaFactura: usoDeLaFactura,
                        regimenFiscal: personaFallback,
                        eMail: eMail,
                        eMailOpcionalNo1: eMailOpcionalNo1,
                        eMailOpcionalNo2: eMailOpcionalNo2,
                        cP: cif.Ubicacion.CodigoPostal ?? "",
                        usoDeLaFactura: 3
                    });

                    var pais = this.lstPais.find(p => p.attributes.idPais == cif.Ubicacion.Pais);

                    this.formDatosClienteAdicionales.setValue({
                        calle: cif.Ubicacion.NombreVialidad ?? "",
                        noExterior: cif.Ubicacion.NoExterior ?? "",
                        noInterior: cif.Ubicacion.NoInterior ?? "",
                        //localidad: null, //cif.Ubicacion.Localidad
                        municipio: null, // cif.Ubicacion.Municipio
                        estado: null, //cif.Ubicacion.EntidadFederativa
                        pais: pais.id,
                        colonia: null,
                        coloniaManual: cif.Ubicacion.Colonia ?? "",
                        isColoniaManual: true,
                    });

                    if (!this.verManualmente) {
                        this.verManualmente = true;
                        this.updateControls();
                    }

                    // Cargar catálogo de regímenes y seleccionar el correcto de la CSF
                    this.getUsoCfdiYRegimenFiscalConCSF(cif.Contribuyente.RFC ?? "", cif.Regimenes ?? []);

                    this.csfCargado = true;

                    this._snackBar.open("Se importo correctamente los datos de la CSF", 'aceptar', { duration: 5000 });
                }
                else {
                    this.store.dispatch(OcultarSpinner());
                    console.log(res.message);
                    this._snackBar.open(res.message, 'aceptar', { duration: 5000 });
                    this.store.dispatch(MostrarExcepcion({ pila: res.message, tipoExcepcion: 4 }));
                }

            } catch (err) {
                this.store.dispatch(OcultarSpinner());
                console.log(err);
                var error = err.error ?? { error: { message: "Error al cargar el archivo" } };
                this._snackBar.open(error.error?.message, 'aceptar', { duration: 5000 });
            }
        }

        /*if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                //this.srcResult = e.target.result;
            };
            reader.readAsArrayBuffer(inputNode.files[0]);
        }*/
    }

    detectaTipoRFC(rfc: string): number {
        // Validar longitud del RFC
        if (rfc.length === 13) {
            return 1; // Persona física
        } else if (rfc.length === 12) {
            return 0; // Persona moral
        } else {
            throw new Error("El RFC proporcionado no tiene un formato válido.");
        }
    }

    //formularios
    formularioCliente() {
        this.formDatosCliente = this.fb.group({
            nombreRazonSocial: new FormControl('', Validators.required),
            rFC: new FormControl('', Validators.required),
            usoDeLaFactura: new FormControl('', Validators.required),
            regimenFiscal: new FormControl('', Validators.required),
            eMail: new FormControl('', Validators.required),
            eMailOpcionalNo1: new FormControl(),
            eMailOpcionalNo2: new FormControl(),
            cP: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
        });
    }

    formularioClienteDatoAdicional() {
        this.formDatosClienteAdicionales = this.fb.group({
            calle: new FormControl(''),
            noExterior: new FormControl(''),
            noInterior: new FormControl(''),
            //localidad:       new FormControl(null),
            municipio: new FormControl(null),
            estado: new FormControl(null),
            pais: new FormControl(null),
            colonia: new FormControl(null),
            coloniaManual: new FormControl(''),
            isColoniaManual: new FormControl(false),
        });

    }

    validateColoniaManual(control: AbstractControl) {
        const parent = control.parent;
        if (parent && parent.get('isColoniaManual')) {
            const isColoniaManual = parent.get('isColoniaManual').value;
            if (isColoniaManual && !control.value) {
                return { required: true };
            }
        }
        return null;
    }

    //banderas
    mostrarDatosAdicionales() {
        this.contadorMostrarDatos++;
        if (this.contadorMostrarDatos % 2) {
            this.datosAdicionales = true;
            this.formDatosClienteAdicionales.enable();
            this.bloquearPaEsMun = true;
            //this.formDatosClienteAdicionales.controls.pais.disable({onlySelf: true});
            //this.formDatosClienteAdicionales.controls.estado.disable({onlySelf: true});
            //this.formDatosClienteAdicionales.controls.municipio.disable({onlySelf: true});
        } else {
            this.datosAdicionales = false;
            this.formDatosClienteAdicionales.disable({ onlySelf: true });
            // this.formDatosClienteAdicionales.reset();
            // this.formDatosCliente.controls.cP.reset();
            this.bloquearPaEsMun = false;
        }
    }

    ActualizarDatosAdicionales() {
        this.datosAdicionales = true;
        this.formDatosClienteAdicionales.enable();
        this.bloquearPaEsMun = true;
        //this.formDatosClienteAdicionales.controls.pais.disable({onlySelf: true});
        //this.formDatosClienteAdicionales.controls.estado.disable({onlySelf: true});
        //this.formDatosClienteAdicionales.controls.municipio.disable({onlySelf: true});
    }

    InsertarCliente() {
        this.formDatosCliente.markAllAsTouched();
        this.formDatosCliente.updateValueAndValidity();
        var flag = false;
        if (this.datosAdicionales
            //this.formDatosCliente.controls.cP.value != null &&
            //this.formDatosCliente.controls.cP.value != ''
        ) {
            this.formDatosClienteAdicionales.markAllAsTouched();
            this.formDatosClienteAdicionales.updateValueAndValidity();
            flag = !(this.formDatosClienteAdicionales.valid && this.formularioCompleto); //false;
        } else {
            flag = true;
        }
        if (!this.formDatosCliente.valid || flag)
            return this._snackBar.open(
                'Favor de completar los datos requeridos',
                'OK',
                { duration: 3000 }
            );
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea guardar este registro?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                console.log("form2", this.formDatosClienteAdicionales)
                this.spinner = true;
                var datosCliente = this.formDatosCliente.controls; //.value;
                var datosClienteAdicionales =
                    this.formDatosClienteAdicionales.controls;
                const direccion = {
                    data: {
                        // //CP: datosCliente.cP,
                        // codigoPostal:datosCliente.cP,
                        calle: datosClienteAdicionales.calle.value,
                        noExterior: datosClienteAdicionales.noExterior.value,
                        noInterior: datosClienteAdicionales.noInterior.value,
                        dir_pai: {
                            id: datosClienteAdicionales.pais.value,
                        },
                        dir_estado: {
                            id: datosClienteAdicionales.estado.value,
                        },
                        dir_municipio: {
                            id: datosClienteAdicionales.municipio.value,
                        },
                        dir_asentamiento: datosClienteAdicionales.isColoniaManual.value
                            ? undefined
                            : { id: datosClienteAdicionales.colonia.value },
                        codigoPostal: datosCliente.cP.value,
                        coloniaManual: datosClienteAdicionales.coloniaManual.value,
                        isColoniaManual:
                            datosClienteAdicionales.isColoniaManual.value,
                        // !datosClienteAdicionales.isColoniaManual ?
                        rfc: datosCliente.rFC.value,
                        ope_empresa: this.data.idEmpresa
                    },
                };

                this.srvcoal
                    .postService(`dir-direcciones`, direccion)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(OcultarSpinner());
                                this._snackBar.open('Ha ocurrido un error al insertar la dirección', 'OK', {
                                    duration: 12000,
                                });
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else {
                                console.log('insert direccion', res);
                                const cliente = {
                                    data: {
                                        nombre: datosCliente.nombreRazonSocial.value,
                                        rfc: datosCliente.rFC.value,
                                        email: datosCliente.eMail.value,
                                        emailOpcional1:
                                            datosCliente.eMailOpcionalNo1.value,
                                        emailOpcional2:
                                            datosCliente.eMailOpcionalNo2.value,
                                        cat_uso_factura: {
                                            id: datosCliente.usoDeLaFactura.value,
                                        },
                                        cat_regimen_fiscal: {
                                            id: datosCliente.regimenFiscal.value,
                                        },
                                        dir_direccion: {
                                            id: res.data.id,
                                        },
                                        ope_empresa: this.data.idEmpresa
                                    },
                                };
                                if (typeof cliente.data.emailOpcional1 === 'string' && cliente.data.emailOpcional1 === "") {
                                    cliente.data.emailOpcional1 = null;
                                }
                                if (typeof cliente.data.emailOpcional2 === 'string' && cliente.data.emailOpcional2 === "") {
                                    cliente.data.emailOpcional2 = null;
                                }

                                //inicia insert cliente
                                this.srvcoal
                                    .postService(`cli-clientes`, cliente)
                                    .subscribe(
                                        (res: any) => {
                                            if (res.err) {
                                                this._snackBar.open('Ha ocurrido un error al insertar cliente', 'OK', {
                                                    duration: 12000,
                                                });
                                                this.store.dispatch(
                                                    OcultarSpinner()
                                                );
                                                this.store.dispatch(
                                                    MostrarExcepcion({
                                                        pila: res.error,
                                                        tipoExcepcion: 4,
                                                    })
                                                );
                                            } else {
                                                this.getCliente(res.data.id)
                                                this._snackBar.open('Cliente agregado correctamente', 'OK', {
                                                    duration: 12000,
                                                });
                                            }
                                        },
                                        (error: any) => {
                                            if (error.status === 400) {
                                                this._snackBar.open(error.error.error.message, 'OK', {
                                                    duration: 12000,
                                                });
                                            } else {
                                                this._snackBar.open('Ha ocurrido un error al insertar cliente', 'OK', {
                                                    duration: 12000,
                                                });
                                            }

                                            this.store.dispatch(
                                                MostrarExcepcion({
                                                    pila: error,
                                                    tipoExcepcion: 2,
                                                })
                                            );
                                            this.store.dispatch(
                                                OcultarSpinner()
                                            );
                                            this.spinner = false;
                                        }
                                    );
                            }
                        },
                        (error: any) => {
                            if (error.status === 400) {
                                this._snackBar.open(error.error.error.message, 'OK', {
                                    duration: 12000,
                                });
                            } else {
                                this._snackBar.open('Ha ocurrido un error al insertar la dirección', 'OK', {
                                    duration: 12000,
                                });
                            }
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                            this.spinner = false;
                        }
                    );
            } else {
                this._snackBar.open('Registro cancelado', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());
                this.spinner = false;
            }
        });
    }
    getCliente(id) {
        /*let idCliente = id
        this.srvcoal
        .getService(`cli-clientes?populate=dir_direccion.dir_asentamiento.dir_codigo_postal,cat_uso_factura,cat_regimen_fiscal,dir_direccion.dir_pai,dir_direccion.dir_estado,dir_direccion.dir_asentaiento,dir_direccion.dir_municipio&filters[id][$eq]=${idCliente}`)
        .subscribe({
            next: (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.error,
                            tipoExcepcion: 4,
                        })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this._snackBar.open(
                        res.data[0].attributes.rfc,
                        'ok',
                        {
                            duration: 3000,
                        }
                    );
                    this.nuevoCliente = res.data[0];
                    console.log('resClinte', res);
                    this.formDatosCliente.reset();
                    this.formDatosClienteAdicionales.reset();
                    this.cerrarCliente(1);
                    this.spinner = false;
                    this.store.dispatch(
                        OcultarSpinner()
                    );
                }
            },
            error: (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: error,
                        tipoExcepcion: 2,
                    })
                );
                this.store.dispatch(
                    OcultarSpinner()
                );
                this.spinner = false;
            }
        });*/

        this._clientService.getClienteById(id).then((res: any) => {
            this._snackBar.open('Cliente registrado correctamente', 'ok', { duration: 3000 });
            this.nuevoCliente = res[0];
            console.log('resClinte', res);
            this.formDatosCliente.reset();
            this.formDatosClienteAdicionales.reset();
            this.cerrarCliente(1);
            this.spinner = false;
            this.store.dispatch(OcultarSpinner());
        }).catch((error: any) => {
            console.error('Error al obtener cliente después de guardar:', error);
            this.store.dispatch(MostrarExcepcion(error));
            this.spinner = false;
            this.store.dispatch(OcultarSpinner());
        });
    }
    UPDCliente() {
        this.formDatosCliente.markAllAsTouched();
        this.formDatosCliente.updateValueAndValidity();
        var flag = false;
        if (this.datosAdicionales
            //this.formDatosCliente.controls.cP.value != null &&
            //this.formDatosCliente.controls.cP.value != ''
        ) {
            this.formDatosClienteAdicionales.markAllAsTouched();
            this.formDatosClienteAdicionales.updateValueAndValidity();
            flag = !(this.formDatosClienteAdicionales.valid && this.formularioCompleto); //false;
        } else {
            flag = true;
        }
        if (!this.formDatosCliente.valid || flag)
            return this._snackBar.open(
                'Favor de completar los datos requeridos',
                'OK',
                { duration: 3000 }
            );
        if (this.actualizar)
            return this._snackBar.open('Operación no válida', 'OK', {
                duration: 3000,
            });
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea actualizar este registro?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                this.spinner = true;
                var datosCliente = this.formDatosCliente.controls; //.value;
                var datosClienteAdicionales =
                    this.formDatosClienteAdicionales.controls; //.value;

                const direccion = {
                    data: {
                        //CP: datosCliente.cP,
                        codigoPostal: datosCliente.cP.value,
                        calle: datosClienteAdicionales.calle.value,
                        noExterior: datosClienteAdicionales.noExterior.value,
                        noInterior: datosClienteAdicionales.noInterior.value,
                        dir_pai: {
                            id: datosClienteAdicionales.pais.value,
                        },
                        dir_estado: {
                            id: datosClienteAdicionales.estado.value,
                        },
                        dir_municipio: {
                            id: datosClienteAdicionales.municipio.value,
                        },
                        dir_asentamiento: {
                            id: datosClienteAdicionales.colonia.value,
                        },
                        coloniaManual: datosClienteAdicionales.coloniaManual.value,
                        isColoniaManual:
                            datosClienteAdicionales.isColoniaManual.value,
                        rfc: datosCliente.rFC.value,
                        ope_empresa: this.data.idEmpresa
                    },
                };

                let idDireccion =
                    this.edicionDatosCliente.attributes.dir_direccion.data.id;
                this.srvcoal
                    .putService(`dir-direcciones/${idDireccion}`, direccion)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                // this._snackBar.open(res, 'ok', {
                                //     duration: 3000,
                                // });
                                const cliente = {
                                    data: {
                                        nombre: datosCliente.nombreRazonSocial.value,
                                        rfc: datosCliente.rFC.value,
                                        email: datosCliente.eMail.value,
                                        emailOpcional1:
                                            datosCliente.eMailOpcionalNo1.value,
                                        emailOpcional2:
                                            datosCliente.eMailOpcionalNo2.value,
                                        cat_uso_factura: {
                                            id: datosCliente.usoDeLaFactura.value,
                                        },
                                        cat_regimen_fiscal: {
                                            id: datosCliente.regimenFiscal.value,
                                        },
                                        dir_direccion: {
                                            id: res.data.id,
                                        },
                                    },
                                };
                                if (typeof cliente.data.emailOpcional1 === 'string' && cliente.data.emailOpcional1 === "") {
                                    cliente.data.emailOpcional1 = null;
                                }
                                if (typeof cliente.data.emailOpcional2 === 'string' && cliente.data.emailOpcional2 === "") {
                                    cliente.data.emailOpcional2 = null;
                                }
                                this.srvcoal
                                    .putService(
                                        `cli-clientes/${this.edicionDatosCliente.id}`,
                                        cliente
                                    )
                                    .subscribe(
                                        (res: any) => {
                                            if (res.err) {
                                                this.store.dispatch(
                                                    MostrarExcepcion({
                                                        pila: res.error,
                                                        tipoExcepcion: 4,
                                                    })
                                                );
                                            } else if (res.excepcion) {
                                                this.store.dispatch(
                                                    MostrarExcepcion({
                                                        pila: res.excepcion,
                                                        tipoExcepcion: 3,
                                                    })
                                                );
                                            } else {
                                                this.getCliente(res.data.id)
                                                this._snackBar.open('Cliente actualizado correctamente', 'OK', {
                                                    duration: 12000,
                                                });
                                                // this.nuevoCliente = res.data;
                                                // this._snackBar.open(
                                                //     res.data.attributes.rfc,
                                                //     'ok',
                                                //     {
                                                //         duration: 3000,
                                                //     }
                                                // );
                                                // this.formDatosCliente.reset();
                                                // this.formDatosClienteAdicionales.reset();
                                                // this.cerrarCliente(1);
                                                // this.spinner = false;
                                                // this.store.dispatch(
                                                //     OcultarSpinner()
                                                // );
                                            }
                                        },
                                        (error: any) => {
                                            this.store.dispatch(
                                                MostrarExcepcion({
                                                    pila: error,
                                                    tipoExcepcion: 2,
                                                })
                                            );
                                            this.store.dispatch(
                                                OcultarSpinner()
                                            );
                                            this.spinner = false;
                                        }
                                    );
                            }
                        },
                        (error: any) => {
                            if (error.status === 400) {
                                this._snackBar.open(error.error.error.message, 'OK', {
                                    duration: 12000,
                                });
                            } else {
                                this._snackBar.open('Ha ocurrido un error al insertar la dirección', 'OK', {
                                    duration: 12000,
                                });
                            }
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                            this.spinner = false;
                        }
                    );
            } else {
                this._snackBar.open('Registro cancelado', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());
                this.spinner = false;
            }
        });
        this.spinner = false;
    }

    ACTCliente() {
        console.log('SOY cliente modificar', this.edicionDatosCliente);
        //this.getUsoCfdiYRegimenFiscal( this.edicionDatosCliente.attributes.rfc ) temporal luis
        let editData = this.edicionDatosCliente.attributes
        console.log(editData);
        const cp = editData.dir_direccion.data.attributes.codigoPostal;
        this.formDatosCliente.controls.nombreRazonSocial.setValue(
            editData.nombre
        );
        this.formDatosCliente.controls.rFC.setValue(
            editData.rfc
        );
        this.formDatosCliente.controls.usoDeLaFactura.setValue(
            editData.cat_uso_factura.data.id
        );
        this.formDatosCliente.controls.regimenFiscal.setValue(
            editData.cat_regimen_fiscal.data.id
        );
        this.formDatosCliente.controls.eMail.setValue(
            editData.email
        );
        this.formDatosCliente.controls.eMailOpcionalNo1.setValue(
            editData.emailOpcional1
        );
        this.formDatosCliente.controls.eMailOpcionalNo2.setValue(
            editData.emailOpcional2
        );
        this.formDatosCliente.controls.cP.setValue(cp);
        if (cp != null) {
            if (this.data.mode !== 3)
                this.mostrarDatosAdicionales();
            //setTimeout(() => this.mostrarDatosAdicionales(), 200);
            /*let idPais =
                editData.dir_direccion.data
                    .attributes.dir_pai.data.id;
            let idEstado =
                editData.dir_direccion.data
                    .attributes.dir_estado.data.id;
            let idMunicipio =
                editData.dir_direccion.data
                    .attributes.dir_municipio.data.id;
            let idAsentamiento =
                editData.dir_direccion.data.attributes.dir_asentamiento?.data?.id;
            //let idAsentamiento =
            //    editData.dir_direccion.data.attributes.codigoPostal === null ?
            //    editData.dir_direccion.data.attributes.dir_asentamiento.data.id:
            //    editData.dir_direccion.data.attributes.codigoPostal;
            this.formDatosClienteAdicionales.controls.pais.setValue(idPais);
            this.changePais(idPais);
            this.formDatosClienteAdicionales.controls.estado.setValue(idEstado);
            this.changeEstado(idEstado);
            this.formDatosClienteAdicionales.controls.municipio.setValue(
                idMunicipio
            );
            this.changeMunicipio(idMunicipio);
            //this.formDatosClienteAdicionales.controls.localidad.setValue(
            //    idAsentamiento
            //);
            this.formDatosClienteAdicionales.controls.colonia.setValue(
                idAsentamiento
            );
            // asigna los valores de coloniaManual y isColoniamanual tomando como base los ejemplos de este metodo
            this.formDatosClienteAdicionales.controls.coloniaManual.setValue(
                editData.dir_direccion.data.attributes.coloniaManual
            );
            this.formDatosClienteAdicionales.controls.isColoniaManual.setValue(
                editData.dir_direccion.data.attributes.isColoniaManual
            );
            this.verManualmente =
                editData.dir_direccion.data.attributes.isColoniaManual;
            this.formularioCompleto = true;
            */
            this.consultarCP(cp).then(res => {
                let idAsentamiento =
                    editData.dir_direccion.data.attributes.dir_asentamiento?.data?.id;
                this.formDatosClienteAdicionales.controls.colonia.setValue(idAsentamiento);
                // asigna los valores de coloniaManual y isColoniamanual tomando como base los ejemplos de este metodo
                this.formDatosClienteAdicionales.controls.coloniaManual.setValue(
                    editData.dir_direccion.data.attributes.coloniaManual
                );
                this.formDatosClienteAdicionales.controls.isColoniaManual.setValue(
                    editData.dir_direccion.data.attributes.isColoniaManual
                );
                this.verManualmente = editData.dir_direccion.data.attributes.isColoniaManual;
                this.formularioCompleto = true;
                this.updateControls();
            });
        }
        this.formDatosClienteAdicionales.controls.calle.setValue(
            editData.dir_direccion.data.attributes
                .calle
        );
        this.formDatosClienteAdicionales.controls.noExterior.setValue(
            editData.dir_direccion.data.attributes
                .noExterior
        );
        this.formDatosClienteAdicionales.controls.noInterior.setValue(
            editData.dir_direccion.data.attributes
                .noInterior
        );

        //console.log(this.formDatosCliente.value);
        //console.log(this.edicionDatosCliente);
    }

    actualizarCliente(edicionDatosCliente) {
        try {
            this.edicionDatosCliente = edicionDatosCliente.data;
            setTimeout(() => this.ACTCliente(), 1000);
        } catch (error) {
            this.Excepciones(error, 1);
        }
    }
    Excepciones(pila, tipoExcepcion: number) {
        try {
            const dialogRef = this.dialog.open(ExcepcionesComponent, {
                width: '60%',
                data: {
                    idTipoExcepcion: tipoExcepcion,
                    idUsuario: 1,
                    idOperacion: 1,
                    idAplicacion: 1,
                    moduloExcepcion: 'sel-caja-historial.component',
                    mensajeExcepcion: '',
                    stack: pila,
                },
            });
            dialogRef.afterClosed().subscribe((result: any) => { });
        } catch (error) {
            // console.error(error);
        }
    }

    CFDI() {
        this.srvcoal.getService('cat-uso-facturas').subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.usoFactura = res.data;
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
        this.srvcoal.getService('cat-regimenes-fiscal').subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.regFiscal = res.data;
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    getPais() {
        this.srvcoal.getService('dir-paises?pagination[start]=0&pagination[limit]=1000').subscribe(
            (res: any) => {
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: res.excepcion,
                            tipoExcepcion: 3,
                        })
                    );
                } else {
                    this.lstPais = res.data;
                }
            },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            }
        );
    }

    changePais(value) {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal
            .getService(`dir-estados?filters[dir_pai][id][$eq]=${value}`)
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.lstEstado = res.data;
                        this.store.dispatch(OcultarSpinner());
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                }
            );
    }

    changeEstado(value) {
        let idPais = this.formDatosClienteAdicionales.controls.pais.value;
        let estado = value;
        this.store.dispatch(MostrarSpinner());
        this.srvcoal
            .getService(
                `dir-municipios?filters[dir_pai][id][$eq]=${idPais}&filters[dir_estado][id][$eq]=${estado}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.lstMunicipio = res.data;
                        this.store.dispatch(OcultarSpinner());
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                }
            );
    }

    changeMunicipio(value) {
        let idPais = this.formDatosClienteAdicionales.controls.pais.value;
        let estado = this.formDatosClienteAdicionales.controls.estado.value;
        let municipio = value;
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.srvcoal
            .getService(
                // `catalogo/GetAsentamiento?idPais=${idPais}&idEstado=${estado}&idMunicipio=${municipio}`
                `dir-asentamientos?filters[dir_municipio][id][$eq]=${municipio}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.lstAsentamiento = res.data;
                        this.store.dispatch(OcultarSpinner());
                        this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
    }

    changeColonia(value) {
        let idPais = this.formDatosClienteAdicionales.controls.pais.value;
        let estado = this.formDatosClienteAdicionales.controls.estado.value;
        let municipio =
            this.formDatosClienteAdicionales.controls.municipio.value;
        let colonia = value;

        // Hacer filter de lstAsentamiento mediante idAsentamiento que sea igual a value
        let asentamiento = this.lstAsentamiento.filter(
            (x) => x.idAsentamiento == value
        );

        console.log('asentamiento', asentamiento);
        //asigna el nombre de la variable asentamiento al input coloniaManual del formgroup
        this.formDatosClienteAdicionales.controls.coloniaManual.setValue(
            asentamiento[0].nombre
        );

        // this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.srvcoal
            .getService(
                `catalogo/GetCP?idPais=${idPais}&idEstado=${estado}&idMunicipio=${municipio}&idAsentamiento=${colonia}`
            )
            .subscribe(
                (res: any) => {
                    // this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.codigoPostal = res.recordsets[0][0].CP;
                        //console.log(res.recordsets[0][0].CP)
                        this.formDatosCliente.controls['cP'].setValue(
                            this.codigoPostal
                        );
                        // this.store.dispatch(OcultarSpinner());
                        // this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    // this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
    }

    async consultarCP(CP: string) {
        /*if (this.formDatosCliente.controls.cP.value === null)
            return this._snackBar.open('Ingrese un CP', 'Ok', {
                duration: 10000,
            });
        let CP = this.formDatosCliente.controls.cP.value;*/

        console.log('Preview 2');
        console.log(CP);

        /*if (this.formDatosCliente.controls.cP.valid === false) {
            this._snackBar.open('Verifique el código postal', 'ok', {
                duration: 3000,
            });
            return;
        }*/

        try {
            this.store.dispatch(MostrarSpinner());
            this.spinner = true;

            const res = await this._facturaService.getDataCodigoPostal(CP);
            console.log("cp", res);
            if (res.success) {
                let pais = res.paises[0].data.id;
                let estado = res.estados[0].data.id;
                let municipio = res.municipios[0].data.id;
                let asentamiento = res.asentamientos[0].data.id;

                this.formDatosClienteAdicionales.controls.pais.setValue(pais);
                this.lstEstado = res.estados.map(e => e.data);

                this.formDatosClienteAdicionales.controls.estado.setValue(estado);
                this.lstMunicipio = res.municipios.map(e => e.data);

                this.formDatosClienteAdicionales.controls.municipio.setValue(municipio);
                this.lstAsentamiento = res.asentamientos.map(e => e.data);

                this.formDatosClienteAdicionales.controls.colonia.setValue(asentamiento);

                this.formularioCompleto = true;

                if (this.data.mode !== 3) {
                    if (this.data) {
                        this.ActualizarDatosAdicionales();
                    } else {
                        this.mostrarDatosAdicionales();
                    }
                }
            } else {
                this.formularioCompleto = false;
                this.formDatosClienteAdicionales.controls.pais.setValue(null);
                this.formDatosClienteAdicionales.controls.estado.setValue(null);
                this.formDatosClienteAdicionales.controls.municipio.setValue(null);
                //this.formDatosClienteAdicionales.controls.localidad.setValue(null);
                this.formDatosClienteAdicionales.controls.colonia.setValue(null);
                this._snackBar.open("No se encontraron coincidencias de CP", 'OK', {
                    duration: 3000,
                });
            }

            this.store.dispatch(OcultarSpinner());
            this.spinner = false;

        } catch (error) {
            this.store.dispatch(
                MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
            );
            this.store.dispatch(OcultarSpinner());
            this.spinner = false;
        }



        // this.srvcoal.getService(`catalogo/GetCP_Origen?CP=${CP}`).subscribe(
        /*this.srvcoal
            .getService(
                `dir-codigos-postales?filters[cp][$eq]=${CP}&populate[dir_asentamiento][populate][dir_municipio][populate][dir_estado][populate][dir_pai][populate]`
            )
            .subscribe({
                next: (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        //this.formDatosClienteAdicionales.reset();
                        let exito = res.meta.pagination.total; //.recordsets[0][0].mensaje;!"·$%&/()=?¿¿¿?=)(/&%$"
                        console.log(res);
                        if (exito >= 1) {
                            let origen = res.data;
                            this.getPais();
                            let pais =
                                origen[0].attributes.dir_asentamiento
                                    .data.attributes.dir_municipio.data
                                    .attributes.dir_estado.data.attributes
                                    .dir_pai.data.id;
                            let estado =
                                origen[0].attributes.dir_asentamiento
                                    .data.attributes.dir_municipio.data
                                    .attributes.dir_estado.data.id;
                            let municipio =
                                origen[0].attributes.dir_asentamiento
                                    .data.attributes.dir_municipio.data
                                    .id;
                            let asentamiento =
                                origen[0].attributes.dir_asentamiento
                                    .data.id;
                            this.formDatosClienteAdicionales.controls.pais.setValue(
                                pais
                            );
                            this.changePais(pais);
                            this.formDatosClienteAdicionales.controls.estado.setValue(
                                estado
                            );
                            this.changeEstado(estado);
                            this.formDatosClienteAdicionales.controls.municipio.setValue(
                                municipio
                            );
                            this.changeMunicipio(municipio);
                            this.formDatosClienteAdicionales.controls.colonia.setValue(
                                asentamiento
                            );
                            //this.formDatosClienteAdicionales.controls.localidad.setValue(
                            //    asentamiento
                            //);
                            this.formularioCompleto = true;
                            console.log("formCliente",this.formDatosClienteAdicionales)
                            if (this.data) {
                                this.ActualizarDatosAdicionales();

                            } else {
                                this.mostrarDatosAdicionales();
                            }
                        } else {
                            this.formularioCompleto = false;
                            this.formDatosClienteAdicionales.controls.pais.setValue(null);
                            this.formDatosClienteAdicionales.controls.estado.setValue(null);
                            this.formDatosClienteAdicionales.controls.municipio.setValue(null);
                            //this.formDatosClienteAdicionales.controls.localidad.setValue(null);
                            this._snackBar.open("No se encontraron coincidencias de CP", 'OK', {
                                duration: 3000,
                            });
                        }
                        this.store.dispatch(OcultarSpinner());
                        this.spinner = false;
                    }
                },
                error: (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }}
            );*/

    }
    KeyUpCP(event) {
        var CP = this.formDatosCliente.controls.cP.value;
        var str = new String(CP);
        var len = str.length;
        if (len == 5) {
            this.consultarCP(CP);
        }
    }
    cerrarCliente(status: any = 0) {
        if (status === 1) {
            this.dialogRef.close({
                success: status,
                nuevoCliente: this.nuevoCliente,
                idProducto: 0,
            });
        } else {
            this.dialogRef.close({ success: status, idProducto: 0 });
        }
    }
    changeVerManualmente() {
        // Cambial el valor de verManualmente a la inversa
        this.verManualmente = !this.verManualmente;
        this.formDatosClienteAdicionales.controls.isColoniaManual.setValue(
            this.verManualmente
        );
        this.updateControls();
    }
    updateControls() {
        if (this.verManualmente) {
            this.formDatosClienteAdicionales.controls.colonia.setValidators(null);
            this.formDatosClienteAdicionales.controls.colonia.updateValueAndValidity();
            this.formDatosClienteAdicionales.controls.coloniaManual.setValidators([Validators.required]);
            this.formDatosClienteAdicionales.controls.coloniaManual.updateValueAndValidity();
        } else {
            this.formDatosClienteAdicionales.controls.colonia.setValidators([Validators.required]);
            this.formDatosClienteAdicionales.controls.colonia.updateValueAndValidity();
            this.formDatosClienteAdicionales.controls.coloniaManual.setValidators(null);
            this.formDatosClienteAdicionales.controls.coloniaManual.updateValueAndValidity();
        }
    }
    getUsoFactura(tipoPersona) {
        console.log('tipoPerona', tipoPersona.isFisico);
        this.srvcoal
            .getService(
                `cat-uso-facturas?filters[aplicaFisico][$eq]=${tipoPersona.isFisico}`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.usoFactura = res.data;
                        this.store.dispatch(OcultarSpinner());
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                }
            );
    }
    getRegimen(tipoPersona) {
        console.log('getRegimen', tipoPersona);

        let query = `cat-regimenes-fiscal?`;

        if (tipoPersona.isFisico) {
            query += `filters[aplicaFisico][$eq]=true&`;
        }

        if (tipoPersona.isMoral) {
            query += `filters[aplicaMoral][$eq]=true&`;
        }

        // Eliminar el último `&` si existe
        query = query.endsWith('&') ? query.slice(0, -1) : query;

        this.srvcoal
            .getService(query)
            .subscribe(
                (res: any) => {
                    this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.regFiscal = res.data;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());
                }
            );
    }
    validaRFCFisica(rfc) {
        const regexPersonaFisica = /^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/;
        const regexPersonaMoral = /^[A-ZÑ&]{3}\d{6}[A-Z0-9]{3}$/;

        let tipoPersona;

        if (regexPersonaFisica.test(rfc)) {
            tipoPersona = 1;
        } else if (regexPersonaMoral.test(rfc)) {
            tipoPersona = 0;
        } else {
            tipoPersona = -1;
        }

        return tipoPersona;
    }

    // Metodo post para obtener de api que se usa en este componente para obtener el uso cfdi y el regimen fiscal
    getUsoCfdiYRegimenFiscal(RFC) {
        let tipoPersona = this.validaRFCFisica(RFC);
        // Si tipoPersoa es gual a -1 manda un mensaje al usuario diciendo que el formato de rfc no es correcto y deten la funcion
        if (tipoPersona == -1) {
            this._snackBar.open('El formato del RFC no es correcto', 'ok', {
                duration: 3000,
            });
            return;
        }

        console.log('getUsoCfdiYRegimenFiscal', tipoPersona);
        // 1 Persona fisica
        // 0 Persona moral


        this.store.dispatch(MostrarSpinner());
        this.spinner = true;
        this.getRegimen({ isFisico: tipoPersona === 0 ? false : true, isMoral: tipoPersona === 0 ? true : false });
        // this.getUsoFactura({ isFisico: tipoPersona === 0 ? false:true,isMoral: tipoPersona === 0 ? true:false });
    }

    // Versión mejorada que recibe los regímenes extraídos de la CSF y selecciona el correcto
    getUsoCfdiYRegimenFiscalConCSF(RFC: string, regimenesCSF: string[]) {
        let tipoPersona = this.validaRFCFisica(RFC);
        if (tipoPersona == -1) {
            this._snackBar.open('El formato del RFC no es correcto', 'ok', { duration: 3000 });
            return;
        }

        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        // Mapeo de descripciones de CSF a claves SAT
        const mapeoRegimenes: { [key: string]: string } = {
            'Actividades Empresariales y Profesionales': '612',
            'Arrendamiento': '606',
            'General de Ley Personas Morales': '601',
            'Personas Morales con Fines no Lucrativos': '603',
            'Sueldos y Salarios': '605',
            'Incorporación Fiscal': '621',
            'Demás ingresos': '608',
            'Consolidación': '609',
            'Residentes en el Extranjero': '610',
            'Ingresos por Dividendos': '611',
            'Ingresos por intereses': '614',
            'Sin obligaciones fiscales': '616',
            'Sociedades Cooperativas de Producción': '620',
            'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras': '622',
            'Opcional para Grupos de Sociedades': '623',
            'Coordinados': '624',
            'Plataformas Tecnológicas': '625',
            'Régimen Simplificado de Confianza': '626',
            'Hidrocarburos': '628',
            'Regímenes Fiscales Preferentes': '629',
            'Enajenación o Adquisición de Bienes': '607',
        };

        let query = `cat-regimenes-fiscal?`;
        if (tipoPersona === 1) {
            query += `filters[aplicaFisico][$eq]=true`;
        } else {
            query += `filters[aplicaMoral][$eq]=true`;
        }

        this.srvcoal.getService(query).subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.spinner = false;
                if (!res.err && !res.excepcion) {
                    this.regFiscal = res.data;

                    // Intentar seleccionar el régimen correcto de la CSF
                    if (regimenesCSF && regimenesCSF.length > 0) {
                        let regimenId = null;

                        for (const regimenCSF of regimenesCSF) {
                            // Buscar en el mapeo qué clave SAT corresponde
                            let claveSAT = null;
                            for (const [keyword, clave] of Object.entries(mapeoRegimenes)) {
                                if (regimenCSF.toLowerCase().includes(keyword.toLowerCase())) {
                                    claveSAT = clave;
                                    break;
                                }
                            }

                            if (claveSAT) {
                                // Buscar en el catálogo cargado el ID que corresponde a esta clave
                                const regimenEncontrado = this.regFiscal.find(
                                    (r: any) => r.attributes.clave === claveSAT
                                );
                                if (regimenEncontrado) {
                                    regimenId = regimenEncontrado.id;
                                    break;
                                }
                            }
                        }

                        if (regimenId) {
                            this.formDatosCliente.controls.regimenFiscal.setValue(regimenId);
                            console.log('Régimen fiscal seleccionado de CSF:', regimenId);
                        } else {
                            console.warn('No se encontró régimen fiscal coincidente de CSF:', regimenesCSF);
                        }
                    }
                }
            },
            (error: any) => {
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                this.store.dispatch(OcultarSpinner());
                this.spinner = false;
            }
        );
    }
}
